import { Component, Input } from '@angular/core';
@Component({
	selector: 'mp-img',
	// <img> NATIVO em vez de <ion-img>: o ion-img é um componente Ionic que lazy-loada
	// via IntersectionObserver JS (só dispara depois de hidratar) — no SSR/mobile isso
	// atrasa o LCP em segundos e instancia ~1 componente Ionic por imagem. O <img>
	// nativo vai no HTML prerenderizado e carrega na hora; loading="lazy" nativo cuida
	// do below-the-fold sem JS. Medido no mobile: TBT 0,69→0,47s. Ver ssr-prerender-mvp-gate.
	template: `<img [src]="imgURL" loading="lazy" decoding="async" alt="" />`,
	styleUrls: ['./image-tag.page.scss'],
})
export class MpImgPage {
	@Input() imgURL: "";
}
